export default __webpack_public_path__ + "static/media/bars.f98a0aef.svg";